import React from "react";
import { useTranslation } from "react-i18next";
import "./buttonViewStyles.css";
import { useFocusable } from "../../../utils/Helpers";
export var LogoutButtonView = function (_a) {
    var onLogout = _a.onLogout, onClose = _a.onClose;
    var t = useTranslation().t;
    var closeRef = useFocusable({
        group: "logoutModal",
        index: 0,
        onKeyDown: onClose,
    });
    var exitRef = useFocusable({
        group: "logoutModal",
        index: 1,
        onKeyDown: onLogout,
    });
    return (React.createElement("div", { className: "btn-container", id: "exit-confirm-modal" },
        React.createElement("button", { tabIndex: 0, ref: closeRef, className: "purple-border-btn" }, t("modal.close")),
        React.createElement("button", { tabIndex: 0, ref: exitRef, className: "purple-border-btn" }, t("modal.exit"))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/buttons/LogoutButtonView.tsx
// module id = 157
// module chunks = 1